const Core = require('./core');
const Actions = require('./actions');

module.exports = {
  startSession: Core.startSession,
  endSession: Core.endSession,

  actions: Actions
};
